import React from 'react';
import cloudDownloadIcon from '../../../assets/images/cloud-download-blue.svg';
import cloudDownloadGreyIcon from '../../../assets/images/cloud-download-grey.svg';
import BaseComponent from '../../../baseClasses/BaseComponent';
import { FileNamePopUp } from '../../../components/FileNamePopup';

import './ExportReport.scss';

// const ExportReport = (props) => {
//   let popUp = props.displayPopUp && <FileNamePopUp handleClosePopup={props.handleClosePopup} fileUrl={props.exportLink} onChange={props.changeFileName} />
//   return (
//     <div>
//       <a className='download-report'   
//         // href={props.exportLink}
//         onClick={props.handleDownloadLocation}
//         download
//       >
//         <img className='cloud-icon' src={props.exportLink != null && props.exportLink != "" ? cloudDownloadIcon : cloudDownloadGreyIcon} alt="Download current view"/>
//         <p className={'export-text' + ((props.exportLink != null && props.exportLink != "") ? '' : ' export-text-grey')}>EXPORT</p>
//       </a>
//     </div>
    
//   )
// }

class ExportReport extends BaseComponent {
  constructor(props) {
    super(props);
    
    this.state= { 
      initializeMe: null,
      
      fileName: this.props.filename,
      change: false,
    };   
      
    this.handleResetFileName = this.handleResetFileName.bind(this);
    
  } 
    
  handleResetFileName(state) {
    this.setState({  change: state });
  }
  render() {
   
    const { exportLink,handleDownloadLocation, displayPopUp, handleClosePopup, changeFileName, filename, selectedCloseouts, description,attachmentIds,location } = this.props;
    let initialName=null;
   
    if (!this.state.change && filename){
      initialName = this.props.filename.split(/\.(?=[\w])/);
      this.state.fileName=initialName[0];
    }
    let selectedFiles=0;
    if (selectedCloseouts && description=='closeoutSummary'){
      selectedFiles=selectedCloseouts.length;
    } else{
      selectedFiles=1;
    }
    // if(reportTitle =="Project Reporting"){
    //   initialName="project_reports"
    // }
    let popUp = displayPopUp && <FileNamePopUp handleClosePopup={handleClosePopup} fileUrl={exportLink} onChange={changeFileName} attachmentIds={attachmentIds}
     popupUbication={'projectCloseout'}  initialName={this.state.fileName} staticName={filename} handleResetFileName={this.handleResetFileName}/>;   
    return (
      <div >
          {popUp}
          <a className='download-report' onClick={selectedFiles >0 ?handleDownloadLocation: null} href={location && location=='timeline'?exportLink:null}>
          <img className='cloud-icon' src={exportLink != null && exportLink != '' && selectedFiles >0 ? cloudDownloadIcon : cloudDownloadGreyIcon} alt="Download current view"/>
          <p className={'export-text' + ((exportLink != null && exportLink != '' && selectedFiles > 0) ? '' : ' export-text-grey')}>EXPORT</p>
          </a>
        </div>
      
    );
  }
}

export default ExportReport;



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ExportReport/index.js